import XhrRequestHandler from '../../lib/XhrRequestHandler';

export interface ITemporality {
  dictemp_nombre: string;
  dictemp_nombre_fiscal: string;
  dictemp_id: string;
  dictemp_amount: string;
}

export class TemporalitySystem {
  private readonly base = '/temporalidad';

  private temporalitys: ITemporality[] = [];

  constructor(private requestHandler: XhrRequestHandler) {}

  getTemporalitys() {
    return this.temporalitys;
  }

  async findTemporalitys(): Promise<ITemporality[]> {
    return this.requestHandler.get<ITemporality[]>(this.base);
  }

  setTemporalitys(temporalitys: ITemporality[]) {
    this.temporalitys = temporalitys;
  }
}
